export function getPositionX(event) {
  if (event.nativeEvent instanceof TouchEvent) return event.nativeEvent.touches[0].clientX;
  if (event.nativeEvent instanceof MouseEvent) return event.nativeEvent.pageX;
  return 0;
}